export default __webpack_public_path__ + "static/media/Teams.21a0e0be.png";